/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { Grid } from '@coursera/cds-core';

import type { WesLogoProps } from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import WesLogo from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import DefaultLoggedInEnterpriseMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/DefaultLoggedInEnterpriseMobileMenuConfig';
import LoggedOutWesMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/LoggedOutWesMobileMenuConfig';
import type { CommonNavProps } from 'bundles/composable-page-header-enterprise/types/wesHeader';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';

const styles = {
  menuIcon: css`
    margin-right: 0;
  `,
};

export interface WesMobileNavProps extends WesLogoProps, CommonNavProps {
  hideMetaNav?: boolean;
}
function WesMobileNav(props: WesMobileNavProps) {
  const enterpriseMyPageHeader = useEnterpriseMyPageHeader();

  return (
    <MainNavigationWrapper>
      <Grid item alignItems="center" container justifyContent="space-between">
        <Grid item>
          <WesLogo logoType={props.logoType} />
        </Grid>
        <Grid item>
          <MobileMenuIconGridItem
            menuConfig={
              isAuthenticatedUser() ? (
                <DefaultLoggedInEnterpriseMobileMenuConfig
                  currentProgram={enterpriseMyPageHeader.currentPageProgram}
                  enrolledDegreePrograms={enterpriseMyPageHeader.enrolledDegreePrograms}
                  enrolledEnterprisePrograms={enterpriseMyPageHeader.enrolledEnterprisePrograms}
                  chosenDegree={enterpriseMyPageHeader.chosenDegree}
                  chosenEnterpriseProgram={enterpriseMyPageHeader.chosenEnterpriseProgram}
                  hasEnrolledPrograms={!!enterpriseMyPageHeader.hasEnrolledPrograms}
                  naptimeManagedThirdPartyOrganizations={enterpriseMyPageHeader.naptimeManagedThirdPartyOrganizations}
                  hasCheatingIncidents={enterpriseMyPageHeader.hasCheatingIncidents}
                  canViewEducatorAdminLink={enterpriseMyPageHeader.canViewEducatorAdminLink}
                />
              ) : (
                <LoggedOutWesMobileMenuConfig
                  hideMetaNav={props.hideMetaNav}
                  renderLoggedOutCtas={props.renderLoggedOutCta}
                />
              )
            }
            homeLogo={<WesLogo logoType={props.logoType} />}
            css={styles.menuIcon}
          />
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
}

export default WesMobileNav;
